var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 472,
    viewBox: "0 0 296 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.406 305.2C283.509 300.304 276.999 297.607 270.073 297.607C263.149 297.607 256.638 300.303 251.74 305.201L173.926 383.016V26.393C173.926 12.098 162.295 0.467041 148 0.467041C133.705 0.467041 122.074 12.097 122.074 26.393V383.017L44.2593 305.2C39.3633 300.304 32.8513 297.607 25.9263 297.607C19.0013 297.607 12.4903 300.303 7.59332 305.201C-2.51468 315.309 -2.51368 331.758 7.59332 341.866L129.667 463.94C134.563 468.836 141.074 471.533 147.999 471.533H148C154.924 471.533 161.435 468.837 166.333 463.94L288.405 341.866C293.302 336.97 296 330.459 296 323.533C296 316.608 293.303 310.098 288.406 305.2Z",
    fill: "#016E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrow);
export default __webpack_public_path__ + "static/media/bottom-arrow.a324168ea7e6185e4550bb2f4e6ee76a.svg";
export { ForwardRef as ReactComponent };